"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaServicesArrowIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m10.527 11.078-.842-1.867c-.588-1.305-1.456-1.269-1.942.07l-3.69 10.153c-.164.45.067.676.513.514l10.148-3.692c1.339-.488 1.37-1.357.07-1.944l-1.856-.837q.59-.555 1.19-1.156c3.861-3.864 6.448-7.54 5.776-8.213s-4.347 1.916-8.209 5.78q-.6.601-1.158 1.192"/></svg>`
}, props));
MediaServicesArrowIcon.displayName = 'MediaServicesArrowIcon';
var _default = exports.default = MediaServicesArrowIcon;